import {StockManagerCellEditorMultipleBarcodesComponent} from '../components/stock-manager-cell-editor-multiple-barcodes/stock-manager-cell-editor-multiple-barcodes.component';
import {StockManagerCellRendererMultipleBarcodesComponent} from '../components/stock-manager-cell-renderer-multiple-barcodes/stock-manager-cell-renderer-multiple-barcodes.component';

export const STOCK_MANAGER_CELL_EDITOR_MULTIPLE_BARCODES = StockManagerCellEditorMultipleBarcodesComponent;
export const STOCK_MANAGER_CELL_RENDERER_MULTIPLE_BARCODES = StockManagerCellRendererMultipleBarcodesComponent;

export const STOCK_MANAGER_GRID_CELL_COMPONENTS = [
  StockManagerCellEditorMultipleBarcodesComponent,
  StockManagerCellRendererMultipleBarcodesComponent,
];
